import i18n from '@/i18n';
import { notification } from 'ant-design-vue';
import { SHOW_NOTIFICATION, SHOW_DEFAULT_ERROR_NOTIFICATION } from './actionTypes';

export default {
  [SHOW_NOTIFICATION](store, { type = 'info', message, ...options }) {
    notification[type]({
      message,
      top: '100px',
      duration: 2,
      ...options,
    });
  },
  [SHOW_DEFAULT_ERROR_NOTIFICATION]() {
    notification.error({
      message: i18n.t('error'),
    });
  },
};
